import {getModelFactory} from "../model-factory/ModelFactory";

const eventBus = {
    on(event: string, callback: ICustomEventListener)
    {
        //document.addEventListener(event, (e) => callback(e));
        document.addEventListener(event, callback as EventListener);
    },
    dispatch(event: string, data?: any)
    {
        document.dispatchEvent(new CustomEvent(event, {detail: data}));
    },
    remove(event: string, callback: ICustomEventListener)
    {
        document.removeEventListener(event, callback as EventListener);
    },
};

interface ICustomEventListener
{
    (evt: CustomEvent): void;
}

export default eventBus;